import React from 'react';
import { Field, Form } from 'react-final-form';

import Grid from '@material-ui/core/Grid';

import Button from '../shared/Button';
import Select from '../shared/Select';
import Input from '../shared/Input';

import { integrationServices, setAllocationStatuses } from '../../constants/enums';

import '../../styles/shared/form.scss';
import WarningIcon from '@material-ui/icons/Error';

const options = [{ label: integrationServices.UNLEASHED.label, value: integrationServices.UNLEASHED.value }];

const IntegrationsForm = (props) => {
  const {
    initialValues,
    onSubmit,
    loading,
  } = props;

  const [apiId, setApiId] = React.useState('');
  const [apiKey, setApiKey] = React.useState('');

  const validate = (values) => {
    const errors = {};

    return errors;
  };

  return (
    <Form
      onSubmit={(formObj) => {
        onSubmit({ ...formObj, apiId, apiKey });
        setApiId('');
        setApiKey('');
      }}
      validate={validate}
      initialValues={{
        ...initialValues,
      }}
      subscription={{ pristine: true, invalid: true }}
    >
      {
        ({ handleSubmit, submitting, invalid, pristine }) => (
          <form onSubmit={handleSubmit} className=''>
            <Grid container spacing={3} style={{ width: 'auto', margin: 0 }}>
              <Grid item xs={12} sm={6}>
                <div>
                  <div className='field__title'>Integration Service</div>
                  <Field name='service'>
                    {({ input, meta }) => (
                      <Select
                        name={input.name}
                        value={input.value}
                        onChange={input.onChange}
                        options={options}
                      />
                    )}
                  </Field>
                </div>

                <div className='m-t-lg'>
                  <div className='field__title'>API Id</div>
                  <Input
                    value={!!initialValues?.enabled ? '************' : apiId}
                    type='text'
                    onChange={(e) => setApiId(e.target.value)}
                    placeholder="Enter API Id"
                    disabled={!!initialValues?.enabled}
                  />
                </div>

                <div>
                  <div className='field__title'>API Key</div>
                  <Input
                    value={!!initialValues?.enabled ? '************' : apiKey}
                    type='text'
                    onChange={(e) => setApiKey(e.target.value)}
                    placeholder="Enter API Key"
                    disabled={!!initialValues?.enabled}
                  />
                </div>

                <div className='d-flex align-start'>
                  <WarningIcon style={{ color: setAllocationStatuses.ASSIGNED.color, marginRight: 4 }} />
                  <div style={{ color: setAllocationStatuses.ASSIGNED.color, fontWeight: 'bold' }}>
                    We take your security seriously. Your API Key and API ID are stored encrypted on our servers and are used only to facilitate the integration for your account. We never share or expose this data.
                  </div>
                </div>
              </Grid>
              <div className='form__actions' style={{ padding: '0 12px 12px' }}>
                <Button
                  type='submit'
                  text='Save Changes'
                  disabled={invalid || loading || pristine || !!initialValues?.enabled}
                  loading={loading}
                  onClick={handleSubmit}
                />
              </div>
            </Grid>
          </form>
        )}
    </Form>
  );
};

export default IntegrationsForm;
